import { Injectable,  OnInit, trigger, EventEmitter, state, style, Output, keyframes,  transition, animate } from '@angular/core';
import { Router } from '@angular/router';
 

import {   HostBinding } from '@angular/core';

import { AngularFireAuthModule } from 'angularfire2/auth';
import { Http, RequestOptions, Headers }       from '@angular/http';

import { AngularFireAuth } from 'angularfire2/auth';
 
//import { moveIn } from '../router.animations';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import * as firebase from 'firebase/app';  
 
import 'rxjs/Rx';
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { URLSearchParams } from '@angular/http'; 
import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import { environment } from 'environments/environment';



 
 
 

@Injectable()
export class LoginService implements OnInit {

    user: Observable<firebase.User>;
    items: FirebaseListObservable<any[]>;


  public  agent: any;

    msgVal: string = '';
flip: string = 'inactive';

   
    isLoggedIn:boolean=false;

hasError:boolean = false;
 
 
    errorMessage:string=""; 

 
 

    public email:string;

    interval: 100;


    display:boolean;
    alive:boolean;
 

getAgentURL:string=environment.apiRoot+"GetAgent";



timer:any;


@Output () public profileUpdateEvent = new EventEmitter <any>();




    constructor(public router: Router, public http:Http,  public afAuth: AngularFireAuth, public af: AngularFireDatabase) {

        this.items = af.list('/messages', {
            query: {
              limitToLast: 50
            }
          });

          this.timer = Observable.timer( 1000, 3000);

          this.timer.subscribe ( t=> { 

         if ( this.isLoggedIn)


             this.onLoggedin(this.agent.email, sessionStorage.getItem("idToken"));
           
 
        
        });

        
}

    ngOnInit() {

        
            
   
       
    }

    
 public    AgentProfileUpdated () {

      this.profileUpdateEvent.emit(this.agent);
      
    }


    onLoggedin(email:string , authToken: any) : Promise <any> {


        console.log("Agents profile was updated");


          let promise = new Promise (  ( resolve, reject ) =>
     
          { 
          

            let params = '';
                        
            
               

                let header = new Headers();

              
                header.append( "Access-Control-Allow-Origin", "*" );
               

               


                
               this.http.get(this.getAgentURL+"?email="+email     )
                .toPromise()
                .then(response =>  { 
                    
                    
                     
                    this.agent = response.json() ;  
                   
                    sessionStorage.setItem('isLoggedin', 'true');
                    
                    this.email=this.agent.email;
                    
                    this.isLoggedIn=true; 
                    
                   
                    this.profileUpdateEvent.emit(this.agent);
            
                   resolve(this.agent);

                
                
                }).catch(error => { reject(error  );}  ) ;

            });


                return promise;

                    
    }
 

 
    GetUserToken( ): Promise<any>  {


    

        let headerToken = new Promise (  ( resolve, reject ) =>
        { 
     
            resolve(""); } 

            );
/** 

              this.afAuth.auth.currentUser.getIdToken(true).then( token =>

                {
                 
                    sessionStorage.setItem( "idToken", token);

                    console.log(token);

              
                     resolve(token);


                 }).catch ( a => reject() );

                } 

           );


           

        
        */


     

        return headerToken;

 
 
          
    }


    login ( email:string, password: string): Promise <any> {


        /** 
       let promise =  new Promise (  ( resolve, reject ) =>
       { 
       
     
       // verify user via firebase sdk 
       
       this.loginFireBase( email, password).then ( response => 
        
        {
     
           

            this.GetUserToken ().then (  authToken => {
              

                   this.onLoggedin(email , authToken).then (  authToken => {
                       resolve();

                   }).catch(error =>  {    reject(error  )});


                  


            } ).catch(error => {   reject(error )} );

            
           

           
          
        
        } 
    
        ).catch(error => {  reject(error )} );
       
       
        });
*/

          return     this.onLoggedin(email , "") ;;

    }
   
     
 
  

    getAgentProfile (): Promise <any> {



        let promise = new Promise (  ( resolve, reject ) =>
        { 

            let agent=null;


            if ( this.isLoggedIn) {

                agent = this.agent;

              
                resolve(agent);

            }

           

        });

        return promise;

    }


    getAgentProfileObservable() : Observable <any>{


        if ( this.isLoggedIn) { 
            let params = '';
               
            let options = new RequestOptions({
                    // Have to make a URLSearchParams with a query string
                    search: new URLSearchParams('email='+this.email) // <-----
                });
               
              
             return this.http.get(this.getAgentURL,options ); 
            }
                    
    }

public getMigrations (): Promise <any>  {

    let promise = new Promise (  ( resolve, reject ) =>
    { 



        let migrations=null;


        if ( this.isLoggedIn) {

            console.info(  this.agent.migrations);
           ;

           
          // Push a search term into the observable stream.
            resolve(this.agent.migrations);

        }

       

    });

    console.info( "SHOULD GET MIGRATIONs" + this.isLoggedIn);


    return promise;


}

    
    logout() {
        this.afAuth.auth.signOut();
    }
    
    Send(desc: string) {
        this.items.push({ message: desc});
        this.msgVal = '';
    }


    
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
      }


    
  

            
 

    
 


       
 
  

 
    
}



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/login/login.service.ts